import { useChartDataWithTranslations } from 'components/charts/inc-charts.hooks';
import IncLineChart from 'components/charts/inc-line-chart/inc-line-chart.component';
import { useSearchQueryContext } from 'components/search/search.hooks';
import { dateXAxis } from 'pages/loyalty-performance-report/loyalty-performance-report.utils';
import { useTranslation } from 'react-i18next';

const BrandSignupTimeSeries = () => {
  const { t } = useTranslation();
  const {
    data,
    queryState: { isFetching },
  } = useSearchQueryContext('brandSignupTimeSeries');
  const series = useChartDataWithTranslations(
    data?.series,
    label => `page.loyaltyPerformanceReport.members.${label}.label`,
  );

  return (
    <IncLineChart
      series={series}
      title={t('page.loyaltyPerformanceReport.members.title')}
      data-testid="BrandSignupTimeSeries.IncLineChart"
      LineChartProps={{
        loading: isFetching,
        xAxis: [dateXAxis(data?.xlabels)],
      }}
    />
  );
};

export default BrandSignupTimeSeries;
